// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar_EIGTH {
  justify-content: space-between !important;
  align-items: center !important;
}

.toolbars_wcyfj {
  min-height: 58px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/events/EventsView.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".toolbar {\n  justify-content: space-between !important;\n  align-items: center !important;\n}\n\n.toolbars {\n  min-height: 58px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `toolbar_EIGTH`,
	"toolbars": `toolbars_wcyfj`
};
export default ___CSS_LOADER_EXPORT___;
